/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIStatement } from '../../models/api/statement.model'

const resource = {
    main: 'services',
    module: 'statements'
}

export class StatementsServices {
    public static getStatements () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getStatementsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getStatementsById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static getStatementsFileById (id: number) {
        return service.get(`${resource.main}/${resource.module}/download/${id}`, {
            responseType: 'arraybuffer'
        })
    }

    public static createStatements (params: APIStatement) {
        const form = new FormData()
        form.append('uploadfile', params.uploadfile)
        form.append('providerId', params.providerId.toString())
        form.append('statementDate', params.statementDate)

        return service.post(`${resource.main}/${resource.module}`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    public static editStatements (id: number, params: APIStatement) {
        const form = new FormData()
        let optionalFile = false
        if (params.uploadfile) {
            form.append('uploadfile', params.uploadfile)
            optionalFile = true
        }
        form.append('providerId', params.providerId.toString())
        form.append('statementDate', params.statementDate)
        form.append('statementId', id.toString())
        form.append('optionalFile', optionalFile.toString())

        return service.put(`${resource.main}/${resource.module}/${id}`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    public static deleteStatements (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
